import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";

export const impressionSplashLottie = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_SPLASH_LOTTIE,
        context,
    });
};
